// removed by extract-text-webpack-plugin
module.exports = {"contactIcon":"styles__contactIcon__3JWCw","infoBlock":"styles__infoBlock__2ykgR","infoContainer":"styles__infoContainer__1kjlb","contactNumberPhone":"styles__contactNumberPhone__2fzOK","contactNumberPhoneContent":"styles__contactNumberPhoneContent__20zJb","contact":"styles__contact__22wb5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactCard/styles.css
// module id = 1694
// module chunks = 0